import { useNavigate } from 'react-router-dom'
import { CoverCard } from '@shared/ui/CoverCard'
import { ROUTES, WEDDING_COURSE_ID } from '@shared/config/routes'
import { useCourses } from '../../../hooks/useApi'
import CourseProgress from './CourseProgress'
import HomeBlock from './HomeBlock'

/**
 * Курсы на главной. В макете блок выделен цветом — это единственный платный
 * раздел, и он не должен теряться среди бесплатных карточек.
 *
 * Начатый курс показываем широкой карточкой первым: к нему возвращаются чаще,
 * чем выбирают новый.
 */
const CoursesBlock = () => {
  const navigate = useNavigate()
  const { data } = useCourses()

  const courses = data?.courses ?? []
  if (courses.length === 0) return null

  const progressOf = (course: (typeof courses)[number]) => {
    const total = course.base.total_lessons || course.base.lesson_count || 0
    const viewed = course.progress?.views ?? 0
    if (total <= 0) return 0
    return Math.min(100, Math.round((viewed / total) * 100))
  }

  // Свадебный курс всегда первый — это флагман, его показывают в первую
  // очередь. Дальше начатые: к ним возвращаются чаще, чем выбирают новый.
  const weight = (course: (typeof courses)[number]) => {
    if (course.base.course_id === WEDDING_COURSE_ID) return 2
    return course.progress ? 1 : 0
  }
  const sorted = [...courses].sort((a, b) => weight(b) - weight(a))

  return (
    <HomeBlock
      title="Курсы"
      subtitle="Новые навыки шаг за шагом"
      tone="accent"
      withLogo
    >
      {sorted.map((course, index) => {
        const percent = progressOf(course)
        return (
          <CoverCard
            key={course.base.course_id}
            title={course.base.name}
            image={course.base.preview_icon_url}
            isLocked={!course.access}
            // Только у первой, широкой карточки: у остальных полоса обычная.
            // Широкой делаем только первую карточку — так в макете.
            isWide={index === 0}
            footer={
              <CourseProgress
                percent={percent}
                lessons={course.base.total_lessons || course.base.lesson_count}
              />
            }
            onClick={() =>
              navigate(ROUTES.COURSE_DETAIL(course.base.course_id))
            }
          />
        )
      })}
    </HomeBlock>
  )
}

export default CoursesBlock
